/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from 'react';
import { classNames } from 'lib/classNames';
import cls from './PopupMenuHeader.module.css';
import { Link } from 'react-router-dom';

export const PopupMenu = (props) => {
  const {
    items,
    stretchIntensity = 1,
    radius = 90,
    startAngle = 185,
    arcSize = 90,
    offsetDown = 10,
    offsetLeft = 20,
    onMenu,
    mobileMenu,
    path,
  } = props;


  const handleMenu = () => {
    onMenu();
  };

  const points = useMemo(() => {
    const points = [];

    const step = arcSize / (items.length - 1);
    const baseDuration = 200 // здесь скорость

    for (let i = 0; i < items.length; i++) {
      const duration = 1100 - (baseDuration + i * 150);

      const angle = startAngle - i * step;
      const angleInRad = (angle * Math.PI) / 180;
      const x = radius * Math.cos(angleInRad) - offsetLeft;
      const baseY = radius * Math.sin(angleInRad);
      const angleProgress = (360 - angle) / 270;
      const extraY = radius * stretchIntensity * Math.pow(angleProgress, 4);
      const y = baseY + extraY + offsetDown;

      points.push({
        x: Math.round(x),
        y: Math.round(y),
        duration,
        ...items[i],
      });
    }

    return points;
  }, [
    arcSize,
    items,
    offsetDown,
    offsetLeft,
    radius,
    startAngle,
    stretchIntensity,
  ]);

  return (
    <>
      <div
        onClick={handleMenu}
        className={classNames(
          cls.circle,
          { [cls['circle_big_open']]: mobileMenu },
          []
        )}
      />
      <div
        onClick={handleMenu}
        className={classNames(
          cls.circle,
          { [cls['circle_small_open']]: mobileMenu },
          []
        )}
      />
      <nav className={cls.menu}>
        <input
          type='checkbox'
          href='#'
          className={cls['menu-open-input']}
          name='menu-open'
          id='menu-open'
        />
        <label
          onClick={handleMenu}
          className={classNames(
            cls['menu-open-label'],
            { [cls['open_menu']]: mobileMenu },
            []
          )}
          for='menu-open'
        >
          <span className={classNames(cls.lines, {}, [cls['line-1']])} />
          <span className={classNames(cls.lines, {}, [cls['line-2']])} />
          <span className={classNames(cls.lines, {}, [cls['line-3']])} />
        </label>

        {points.map((point, index) => {
          return (
            <Link
              to={point.path}
              onClick={handleMenu}
              key={index}
              className={classNames(
                cls['menu-item'],
                { 
                  [cls['selected-menu-item']]: point.path === path ,
                }
                ,
                []
              )}
              style={{
                '--item-x': `${point.x}px`,
                '--item-y': `${point.y}px`,
                '--item-duration': `${point.duration}ms`,
              }}
            >
              {point.label}
            </Link>
          );
        })}
      </nav>
    </>
  );
};
